import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 3l6 6","key":"svg-0"}],["path",{"d":"M9 9l6 -6","key":"svg-1"}],["path",{"d":"M9 15l3 4.5","key":"svg-2"}],["path",{"d":"M15 15l-4.5 7","key":"svg-3"}],["path",{"d":"M5 12h14","key":"svg-4"}]]

const IconMathXDivideY = createReactComponent('outline', 'math-x-divide-y', 'MathXDivideY', __iconNode);

export default IconMathXDivideY;